import React from 'react';
import './App.css';

// Import Components
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import Courses from './components/Courses/Courses';
import Reviews from './components/Reviews/Reviews';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Home />
        <Courses />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
